import { FormlyFieldConfig } from '@ngx-formly/core';
import type { FormlyHookFn } from './formly-hook-fn.type';
import { combineLatest } from 'rxjs';
import {
  distinctUntilChanged,
  map,
  startWith,
  takeUntil,
} from 'rxjs/operators';
import { formCondition } from './form-data.utility';

export const conditionalSynchronizeHook = (
  synchronizedUpdates,
  destroyed$
): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    let conditions = field.props.synchronizeConditions;
    let root: FormlyFieldConfig = field;
    let isRoot = false;
    while (!isRoot) {
      if (!root.parent) {
        isRoot = true;
      } else {
        root = root.parent;
      }
    }

    conditions.forEach((cond) => {
      const f = cond.keyIsGlobal ? root.formControl : field.parent.formControl;
      const ctrl = f.get(cond.key);

      if (ctrl == null) {
        console.log(
          `${cond.key} is not associated with a form control - consider setting "keyIsGlobal: true" on ${field.key} if this is an expected form control (conditionalSynchronize)`
        );
        return;
      }

      const conditionEvaluationResult = ctrl.valueChanges.pipe(
        startWith(ctrl.value), // Trigger evaluation on form load
        map(() => formCondition(cond, field, root))
      );

      const fieldChanges = field.formControl.valueChanges.pipe(
        startWith(field.formControl.value)
      );

      combineLatest([fieldChanges, conditionEvaluationResult])
        .pipe(takeUntil(destroyed$), distinctUntilChanged())
        .subscribe(([newSynchronizeVal, conditionIsTrue]) => {
          const fieldToSync = cond.valueToSync;
          if (conditionIsTrue) {
            if (fieldToSync.startsWith('applicationUDF:')) {
              const udfName = fieldToSync.split(':')[1];
              if (!synchronizedUpdates.applicationUDFs) {
                synchronizedUpdates.applicationUDFs = {};
              }

              synchronizedUpdates.applicationUDFs[udfName] = newSynchronizeVal;
            } else {
              synchronizedUpdates[fieldToSync] = newSynchronizeVal;
            }
          } else {
            if (
              fieldToSync.startsWith('applicationUDF:') &&
              synchronizedUpdates.applicationUDFs[fieldToSync.split(':')[1]] !==
                undefined
            ) {
              delete synchronizedUpdates.applicationUDFs[
                fieldToSync.split(':')[1]
              ];
            } else if (synchronizedUpdates[fieldToSync] !== undefined) {
              delete synchronizedUpdates[fieldToSync];
            }
          }
        });
    });
  };
};
